module.exports = __webpack_public_path__ + "static/media/20.a76e72a7.wav";